import Layout from '@/layout'

const businessAreaRouter = {
  path: '/audit',
  component: Layout,
  // name: 'Nested',
  meta: {
    title: 'Kiểm toán'
  },
  children: [
    {
      path: '/audit',

      name: '',
      // meta: { title: 'Kiểm toán' },
      component: () => import('@/views/mci/audit/index.vue')
    }
  ]
}

export default businessAreaRouter
